'use client';

import { useMemo, useState } from 'react';
import { MissingSelectionValuesContext } from './contexts/MissingSelectionValuesContext';
import {
  MissingMonogramValuesPerConfig,
  MissingOptionsPerConfiguration,
  MissingOptionValuesPerConfiguration,
} from '../utils/preloadConfiguration/preloadConfiguration';

export type MissingSelectionValuesContextProviderProps = {
  children: React.ReactNode;
  defaultShowMissingFabricModal: boolean;
  defaultShowMissingOptionsPanel: boolean;
  defaultMonogramsIdsWithMissingSelection: number[];
  defaultMissingOptionValuesPerConfig: MissingOptionValuesPerConfiguration;
  defaultMissingMonogramValuesPerConfig: MissingMonogramValuesPerConfig;
  defaultMissingOptionsPerConfig: MissingOptionsPerConfiguration;
};

export const MissingSelectionValuesContextProvider = ({
  children,
  defaultShowMissingFabricModal,
  defaultShowMissingOptionsPanel,
  defaultMonogramsIdsWithMissingSelection,
  defaultMissingOptionValuesPerConfig,
  defaultMissingMonogramValuesPerConfig,
  defaultMissingOptionsPerConfig,
}: MissingSelectionValuesContextProviderProps) => {
  const [showMissingFabricModal, setShowMissingFabricModal] = useState<boolean>(defaultShowMissingFabricModal);
  const [showMissingOptionsPanel, setShowMissingOptionsPanel] = useState<boolean>(defaultShowMissingOptionsPanel);
  const [monogramsIdsWithMissingSelection, setMonogramsIdsWithMissingSelection] = useState<number[]>(
    defaultMonogramsIdsWithMissingSelection,
  );
  const [missingOptionValuesPerConfig, setMissingOptionValuesPerConfig] = useState<MissingOptionValuesPerConfiguration>(
    defaultMissingOptionValuesPerConfig,
  );
  const [missingMonogramValuesPerConfig, setMissingMonogramValuesPerConfig] = useState<MissingMonogramValuesPerConfig>(
    defaultMissingMonogramValuesPerConfig,
  );
  const [missingOptionsPerConfig, setMissingOptionsPerConfig] =
    useState<MissingOptionsPerConfiguration>(defaultMissingOptionsPerConfig);
  const [isSummaryValidationTriggered, setIsSummaryValidationTriggered] = useState<boolean>(false);
  const contextValue = useMemo(() => {
    return {
      showMissingFabricModal,
      setShowMissingFabricModal,
      showMissingOptionsPanel,
      setShowMissingOptionsPanel,
      monogramsIdsWithMissingSelection,
      setMonogramsIdsWithMissingSelection,
      missingOptionValuesPerConfig,
      setMissingOptionValuesPerConfig,
      missingMonogramValuesPerConfig,
      setMissingMonogramValuesPerConfig,
      missingOptionsPerConfig,
      setMissingOptionsPerConfig,
      isSummaryValidationTriggered,
      setIsSummaryValidationTriggered,
    };
  }, [
    showMissingFabricModal,
    showMissingOptionsPanel,
    monogramsIdsWithMissingSelection,
    missingOptionValuesPerConfig,
    missingMonogramValuesPerConfig,
    missingOptionsPerConfig,
    isSummaryValidationTriggered,
  ]);

  return (
    <MissingSelectionValuesContext.Provider value={contextValue}>{children}</MissingSelectionValuesContext.Provider>
  );
};
